import type { Location } from 'react-router';

import { LOCATION_CHANGE } from './actionTypes';
import type { LocationChangeAction, RouterAction } from './types';

export const locationChange = (location: Location, action: RouterAction): LocationChangeAction => ({
  type: LOCATION_CHANGE,
  payload: { location, action },
});
